import { DataSourceMode, TableRowDisplayEvent } from "@mcleod/components";
import { OtherChargeChangeCompareItem } from "./OtherChargeChangeCompareItem";
import { OtherChargeCompareItem } from "./OtherChargeCompareItem";
import { AutogenLayoutOtherChargeCompare } from "./autogen/AutogenLayoutOtherChargeCompare";
import { BaseCompare, TableConfig } from "./BaseCompare";

export class OtherChargeCompare extends AutogenLayoutOtherChargeCompare {
    private _newOrRemovedOtherCharges: any[] = [];
    private _changedOtherCharges: any[] = [];
    private baseCompare = new BaseCompare();

    // Delegate properties to baseCompare
    get isOrderUpdateAllowed(): boolean { return this.baseCompare.isOrderUpdateAllowed; }
    set isOrderUpdateAllowed(value: boolean) { this.baseCompare.isOrderUpdateAllowed = value; }

    get newOrRemovedOtherCharges(): any[] { return this._newOrRemovedOtherCharges; }
    set newOrRemovedOtherCharges(value: any[]) { this._newOrRemovedOtherCharges = value; }

    get changedOtherCharges(): any[] { return this._changedOtherCharges; }
    set changedOtherCharges(value: any[]) { this._changedOtherCharges = value; }

    get isInvoice(): boolean { return this.baseCompare.isInvoice; }
    set isInvoice(value: boolean) { this.baseCompare.isInvoice = value; }

    get isCompareHistory(): boolean { return this.baseCompare.isCompareHistory; }
    set isCompareHistory(value: boolean) { this.baseCompare.isCompareHistory = value; }

    setupTableData(mode: DataSourceMode): void {
        const tableConfigs: TableConfig[] = [
            {
                table: this.tableOtherCharge,
                label: this.labelOtherChargeAddsAndDeletes,
                data: this.newOrRemovedOtherCharges
            },
            {
                table: this.tableOCChanges,
                label: this.labelChanges,
                data: this.changedOtherCharges
            }
        ];

        this.baseCompare.setupTableData(tableConfigs, mode);
    }

    onOtherChargeRowDisplay(event: TableRowDisplayEvent): void {
        this.baseCompare.handleAddDeleteRowDisplay(
            event,
            this.newOrRemovedOtherCharges,
            OtherChargeCompareItem,
            OtherChargeChangeCompareItem,
            true
        );
    }

    onOCChangeDisplay(event: TableRowDisplayEvent): void {
        this.baseCompare.handleChangeRowDisplay(
            event,
            this.changedOtherCharges,
            OtherChargeCompareItem,
            OtherChargeChangeCompareItem
        );
    }
}